import { DestinationForm } from "@prequel/react";

import axios, { ApiResponse, ApiRoutes } from "@/api/client";
import {
  createResource,
  deleteResource,
  getAllPages,
  getResource,
  getResourcePage,
  handleApiError,
} from "@/api/helpers";
import { ExistingMagicLink, MagicLink, PaginationParams, PaginationResponse } from "@/types";

const getMagicLinks = async (paginationParams: PaginationParams): Promise<PaginationResponse<ExistingMagicLink>> =>
  getResourcePage<ExistingMagicLink, { magic_links: ExistingMagicLink[] }>(
    ApiRoutes.MAGIC_LINKS,
    paginationParams,
    (response: ApiResponse<{ magic_links: ExistingMagicLink[] | null }>) => response.data.data.magic_links ?? [],
    "Failed to fetch magic links.",
  );

const getAllMagicLinks = async (): Promise<ExistingMagicLink[]> => getAllPages(getMagicLinks);

const getMagicLink = async (magicLinkID: ExistingMagicLink["id"]): Promise<ExistingMagicLink> =>
  getResource<ExistingMagicLink, { magic_link: ExistingMagicLink }>(
    `${ApiRoutes.MAGIC_LINKS}/${magicLinkID}`,
    (response: ApiResponse<{ magic_link: ExistingMagicLink }>) => response.data.data.magic_link,
    "Failed to fetch magic link.",
  );

const postMagicLink = (link: MagicLink): Promise<ExistingMagicLink> =>
  createResource<MagicLink, ExistingMagicLink>(
    ApiRoutes.MAGIC_LINKS,
    link,
    "magic_link",
    "magic_link",
    "Failed to post magic link.",
  );

const getMagicLinkForm: () => Promise<DestinationForm> = () =>
  axios
    .get(ApiRoutes.PUBLIC_MAGIC_LINK_FORM)
    .then((response: ApiResponse<DestinationForm>) => response.data.data)
    .catch(handleApiError("Failed to fetch magic link vendors."));

const deleteMagicLink = (id: ExistingMagicLink["id"]): Promise<void> =>
  deleteResource(`${ApiRoutes.MAGIC_LINKS}/${id}`, "Failed to delete magic link.");

const MagicLinksService = {
  getMagicLinks,
  getAllMagicLinks,
  getMagicLink,
  postMagicLink,
  getMagicLinkForm,
  deleteMagicLink,
};
export default MagicLinksService;
